import { Skeleton, Td, Tr } from '@chakra-ui/react'

export default function TableBodyLoading({
  columns,
  rows,
  height
}: {
  rows?: number
  columns?: number
  height?: string
}) {
  return (
    <>
      {Array.from(new Array(rows ?? 3)).map((_, i) => {
        return (
          <Tr key={i}>
            {Array.from(new Array(columns ?? 1)).map((_, i) => {
              return (
                <Td key={i}>
                  <Skeleton height={height ?? '4rem'} />
                </Td>
              )
            })}
          </Tr>
        )
      })}
    </>
  )
}
